import { PlanResponse } from '@/planList/domain/PlanResponse';
import { PlanStickyBox } from '@/planList/domain/PlanStickyBox';
import { dateHelpers } from '@hfc/ui-core';

interface UseStickyBoxInterface {
  getStickyBoxCompatiblePlan: (plan: Array<PlanStickyBox>, effectiveDate?: number, useSubCarrier?: boolean) => string;
}

const { fromUtcTimestampToLocaleTimestamp } = dateHelpers();

export const useStickyBox = (): UseStickyBoxInterface => {
  const getStickyBoxCompatiblePlan = (plans: Array<PlanStickyBox>, effectiveDate?: number, useSubCarrier?: boolean): string => {
    return JSON.stringify(plans.map(plan => ({
      name: plan.name,
      coverageType: plan.coverage_type,
      allowPlanChange: plan.allowPlanChange,
      confirmationNumber: plan.confirmationNumber,
      allowPriceChange: false,
      effectiveDate: effectiveDate ? fromUtcTimestampToLocaleTimestamp(effectiveDate) : null,
      subsidy: null,
      notes: [],
      price: plan.rate,
      hash: plan.hash || '',
      carrier: getCarrierData(plan, useSubCarrier),
    })));
  };

  function getCarrierData (plan: PlanResponse, useSubCarrier?: boolean): string {
    if (useSubCarrier && plan.sub_carrier) {
      return JSON.stringify({
        ...plan.sub_carrier,
        codeName: plan.sub_carrier?.code_name,
      });
    }

    return JSON.stringify({
      ...plan.carrier,
      codeName: plan.carrier?.code_name,
    });
  }

  return {
    getStickyBoxCompatiblePlan,
  };
};
